module.exports = __webpack_public_path__ + "img/hanchuang-propa.5b182a49.png";